import './App.css';
import { BrowserRouter,Route,Routes  } from 'react-router-dom';
import Home from './components/Home/Home';
import Termin from './components/Termin/Termin';
import Signup from './components/Signup/Signup';
import Login from './components/Login/Login'
import Profile from './components/Profile/Profile';
import EmployeeCalendar from './components/employeeCalendar/EmployeeCalendar';
import AllTerminTable from './components/allTerminsTable/AllTerminTable';
import Navbar from './components/navbar/Navbar';
import TerminAcc from './components/TerminAcc/TerminAcc';
import SingleTermin from './components/SingleTermin/SingleTermin';

function App() {

  return (
    <BrowserRouter>
      <Navbar/>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/termin" element={<Termin/>} />
          <Route path="/terminacc" element={<TerminAcc/>} />
          <Route path="/auth/signup" element={<Signup/>} />
          <Route path="/auth/login" element={<Login/>} />
          <Route path="/auth/profile/:id" element={<Profile/>} />
          <Route path="/termin/all-termins" element={<AllTerminTable/>} />
          <Route path="/termin/termin-calendar" element={<EmployeeCalendar/>} />
          <Route path="/termin/single/:id" element={<SingleTermin/>} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
